import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { SubscriptionType } from "common/types";

import useInvoices from "../../datahooks/useInvoices";
import DesktopTable from "./DesktopTable";
import MobileList from "./MobileList";

import NoInvoicesFound from "assets/images/empty-placeholders/invoices.png";

export default function Invoices({ type }: { type: SubscriptionType }) {
  const isDesktop = useTwBreakpoint("lg");
  const { invoices, isLoadingInvoices, isInvoicesError, refetchInvoices } =
    useInvoices(type);

  if (isInvoicesError) {
    return (
      <ErrorPlaceholder
        errorMessage="Could not display invoices"
        onRetry={refetchInvoices}
      />
    );
  } else if (isLoadingInvoices) {
    return <Loader />;
  } else if (!invoices || !invoices.length) {
    return (
      <EmptyPlaceholder
        title="No invoices found"
        subtitle="There are no invoices to display"
        imageSrc={NoInvoicesFound}
      />
    );
  }

  const Table = isDesktop ? DesktopTable : MobileList;

  return <Table invoices={invoices} />;
}
